const ahoy = require('ahoy.js');
window.ahoy = ahoy.default || ahoy;